/**
 * te24-versandzeit.js
 * ---------------------------------------------------------------
 * Rendert alle [data-te24-versandzeit] Elemente auf der Seite.
 * Liest die Rohdaten aus data-Attributen (vom Liquid-Snippet gesetzt,
 * kommen aus den strukturierten Metafeldern custom.bearbeitungszeit_tage_min/max
 * und custom.versanddauer_tage_min/max) und berechnet daraus echte
 * Kalenderdaten unter Ausschluss von Wochenenden (reine Werktage,
 * kein Cutoff, keine Feiertage).
 */
(function () {
  'use strict';

  function isWeekend(d) {
    var day = d.getDay();
    return day === 0 || day === 6;
  }

  function addBusinessDays(start, days) {
    var d = new Date(start);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (!isWeekend(d)) added++;
    }
    return d;
  }

  function getOrderDate() {
    var now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
  }

  function fmt(d) {
    return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' });
  }

  function fmtLong(d) {
    return d.toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' });
  }

  function intAttr(el, name) {
    var raw = el.getAttribute(name);
    if (raw === null || raw === '') return null;
    var n = parseInt(raw, 10);
    return isNaN(n) ? null : n;
  }

  function auslieferungText(versandart, el) {
    if (versandart === 'Spedition') {
      return el.getAttribute('data-text-spedition') ||
        'Anlieferung mit telefonischer Terminankündigung';
    }
    return el.getAttribute('data-text-paketdienst') ||
      'Zustellung direkt an Ihre Haustür';
  }

  function renderAnfrage(el, mode) {
    var customText = el.getAttribute('data-anfrage-text');
    var subText = customText || 'Aktuell nicht auf Lager &ndash; kontaktieren Sie uns für den nächsten Liefertermin.';
    var html;
    if (mode === 'full') {
      html =
        '<div class="te24-vz-anfrage">' +
        '<div>' +
        '<p class="te24-vz-anfrage-title">Lieferzeit: auf Anfrage</p>' +
        '<p class="te24-vz-anfrage-sub">' + subText + '</p>' +
        '</div></div>';
    } else if (mode === 'mini' || mode === 'cart') {
      html =
        '<div class="te24-vz-mini-row">' +
        '<span class="te24-vz-mini-label">Lieferzeit</span>' +
        '<span class="te24-vz-mini-value">auf Anfrage</span>' +
        '</div>';
    } else {
      html = '<span class="te24-vz-badge te24-vz-badge--anfrage">Lieferzeit auf Anfrage</span>';
    }
    el.innerHTML = html;
  }

  function renderCompact(el, minDate, maxDate) {
    var text = minDate.getTime() === maxDate.getTime()
      ? 'Lieferung ca. ' + fmt(minDate)
      : 'Lieferung ca. ' + fmt(minDate) + '–' + fmt(maxDate);
    el.innerHTML = '<span class="te24-vz-badge">' + text + '</span>';
  }

  function renderMini(el, minDate, maxDate) {
    var range = minDate.getTime() === maxDate.getTime()
      ? fmt(minDate)
      : fmt(minDate) + '–' + fmt(maxDate);
    el.innerHTML =
      '<div class="te24-vz-mini-row">' +
      '<span class="te24-vz-mini-label">Lieferzeit</span>' +
      '<span class="te24-vz-mini-value">ca. ' + range + '</span>' +
      '</div>';
  }

  function step(label, date, active) {
    return (
      '<div class="te24-vz-step' + (active ? ' te24-vz-step--active' : '') + '">' +
      '<span class="te24-vz-step-dot"></span>' +
      '<span class="te24-vz-step-label">' + label + '</span>' +
      '<span class="te24-vz-step-date">' + fmt(date) + '</span>' +
      '</div>'
    );
  }

  function renderFull(el, orderDate, handoverMin, handoverMax, deliveryMin, deliveryMax, versandart) {
    var deliveryRange = deliveryMin.getTime() === deliveryMax.getTime()
      ? fmtLong(deliveryMin)
      : fmtLong(deliveryMin) + ' – ' + fmtLong(deliveryMax);

    var lastStepLabel = auslieferungText(versandart, el);

    var html =
      '<div class="te24-vz-full">' +
      '<div class="te24-vz-full-head">' +
      '<span class="te24-vz-full-date">Voraussichtliche Lieferung: ' + deliveryRange + '</span>' +
      (versandart ? '<span class="te24-vz-full-badge">' + versandart + '</span>' : '') +
      '</div>' +
      '<div class="te24-vz-timeline">' +
      step('Bestellung', orderDate, true) +
      step('Bearbeitung', handoverMin, false) +
      step('Versand', handoverMax, false) +
      step('Auslieferung', deliveryMax, false) +
      '</div>' +
      '<p class="te24-vz-full-note">' + lastStepLabel + '</p>' +
      '</div>';
    el.innerHTML = html;
  }

  function render(el) {
    var mode = el.getAttribute('data-mode') || 'compact';
    var stock = el.getAttribute('data-stock');
    var versandart = el.getAttribute('data-versandart') || '';

    var bMin = intAttr(el, 'data-bearbeitung-min');
    var bMax = intAttr(el, 'data-bearbeitung-max');
    var vMin = intAttr(el, 'data-versand-min');
    var vMax = intAttr(el, 'data-versand-max');

    if (stock === 'out') {
      renderAnfrage(el, mode);
      return;
    }

    if (bMin === null || bMax === null || vMin === null || vMax === null) {
      // Fehlende Daten (Migration/Versandart noch nicht gepflegt) -> Block bleibt leer.
      el.innerHTML = '';
      return;
    }

    var orderDate = getOrderDate();
    var handoverMin = addBusinessDays(orderDate, bMin);
    var handoverMax = addBusinessDays(orderDate, bMax);
    var deliveryMin = addBusinessDays(orderDate, bMin + vMin);
    var deliveryMax = addBusinessDays(orderDate, bMax + vMax);

    if (mode === 'full') {
      renderFull(el, orderDate, handoverMin, handoverMax, deliveryMin, deliveryMax, versandart);
    } else if (mode === 'mini' || mode === 'cart') {
      renderMini(el, deliveryMin, deliveryMax);
    } else {
      renderCompact(el, deliveryMin, deliveryMax);
    }
  }

  function init() {
    var nodes = document.querySelectorAll('[data-te24-versandzeit]');
    for (var i = 0; i < nodes.length; i++) {
      render(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Bei Variantenwechsel auf der Produktseite neu berechnen
  // (relevant, falls Lagerbestand je Variante variiert).
  document.addEventListener('variant:change', init);

  // Bei Warenkorb-Updates (Drawer-Neuaufbau) neu initialisieren.
  document.addEventListener('cart:updated', init);
  document.addEventListener('te24:cart:updated', init);
})();
